import React from "react";
import Client from "./clientWrapper/Client";
import { Query } from "react-apollo";
import { getClients, getClientsByUser } from "../../graphql/query/client";
import AntSpin from "../common/AntSpin";
import Exception500 from "../common/exception/500";

export default function ClientWrapper({history, REMOVE_CLIENT, user}){
    if(!user.profile_info) return <AntSpin/>
    else return(
        <Query 
            query={user.profile_info[0].label !== "User" ? getClients : getClientsByUser } 
            variables={{ user: localStorage.getItem('@Ossel:userid') }}
        >
            {({ loading, error, refetch, data }) => {
                if(error){
                    return <Exception500/>
                }else{
                    switch(loading ){
                        case true:
                            return <AntSpin marginTop="10%"/> 
                        case false:
                            let props = {
                                clients: user.profile_info[0].label !== "User" ? data.clients : data.clientsByUser,
                                history,
                                refetch,
                                REMOVE_CLIENT,
                                user
                            };
        
                            return <Client props={props}/>
                        default:
                            return null
                    }    
                }
            }}
        </Query>
    )
}


// WEBPACK FOOTER //
// ./src/components/general/ClientWrapper.jsx